// ProductActionSticky
// Observeert .js-product-action-default en toggelt .is-visible op .js-product-action-sticky
// Regels:
// - Toon sticky pas wanneer de top van het default-blok boven de viewport is (rect.top <= 0)
// - Verberg sticky wanneer gebruiker aan de onderkant van de pagina is
// - Herstel sticky weer bij omhoog scrollen als aan voorwaarden wordt voldaan

(function () {
    if (typeof window === 'undefined' || typeof document === 'undefined') return;

    const defaultBlock = document.querySelector('.js-product-action-default');
    const stickyBlock = document.querySelector('.js-product-action-sticky');

    if (!defaultBlock || !stickyBlock) return;

    const setVisible = (shouldShow) => {
        if (shouldShow) stickyBlock.classList.add('is-visible');
        else stickyBlock.classList.remove('is-visible');
    };

    const updateVisibility = () => {
        const rect = defaultBlock.getBoundingClientRect();
        const doc = document.documentElement;
        const scrollY = window.pageYOffset || doc.scrollTop || 0;
        const viewportH = window.innerHeight || doc.clientHeight;
        const scrollBottom = scrollY + viewportH;
        const scrollHeight = Math.max(doc.scrollHeight, doc.offsetHeight);

        // Toon sticky pas als het default-blok volledig uit beeld is aan de bovenzijde
        // (dus onderkant is boven of gelijk aan 0)
        const fullyOutTop = rect.bottom <= 0;

        // Verberg sticky wanneer onderaan de pagina (kleine marge tegen afrondingsfouten)
        const AT_BOTTOM_TOLERANCE = 2; // px
        const atBottom = scrollBottom >= (scrollHeight - AT_BOTTOM_TOLERANCE);

        setVisible(fullyOutTop && !atBottom);
    };

    // Eenduidige scroll/resize/orientation handler (betrouwbaarder voor deze regels)
    window.addEventListener('scroll', updateVisibility, { passive: true });
    window.addEventListener('resize', updateVisibility);
    window.addEventListener('orientationchange', updateVisibility);
    // Initiële staat bepalen
    updateVisibility();
})();

export default {};
